App.factory('fieldsService', ['$q', 'baseService', 'Config', '$rootScope', function($q, baseService, Config, $rootScope) {
    function FieldsService() {
        this.dataFieldsList = function() {
            return baseService.getWithOutAuth($rootScope.CONFIGURATOR.lifeInsurance.productDetailsUrl).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
        
    }
    return new FieldsService();
}]);